import { Dictionary, Skyward, EventDictionary } from "./types";
import { registerEvents } from "./skyward.ui.events";
const _registeredScripts: Dictionary<string, true> = Object.create(null);

/**
* Registers a script with a namespace
* @param {String} namespace The namespace of the script that will be registered
* @param {Function} callback A function to call to initialize the script, should return an events object
*/
export function registerScript(namespace: string, callback: (skyward: Skyward, $: JQueryStatic) => EventDictionary): void
{
    if (_registeredScripts[namespace])
    {
        return;
    }

    if (typeof callback === "function")
    {
        _registeredScripts[namespace] = true;

        registerEvents(namespace, callback(window.skyward, window.jQuery));
    }
};